import axios from "axios";
import appConfig from "config/appConfig";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter, Switch, Route } from "react-router-dom";
import { loadPlan } from "store/actions/planAction";
import { loadYear } from "store/actions/yearAction";


const Loader = () => {
  const [showLoader, setShowLoader] = useState(true);

  return (
    <div>
      <style>
        {`
          .loader {
            border: 4px solid #f3f3f3;
            border-top: 4px solid #3498db;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin 2s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .loader-circle {
            border: 4px solid #3498db;
            border-top: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin 2s linear infinite;
          }
        `}
      </style>
      {showLoader && (
        <div className="loader">
          <div className="loader-circle"></div>
        </div>
      )}
      
    </div>
  );
};
const DownLoadReceipt = ({props}) => {

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  const handleDownload = () => {
    const currentPathname = window.location.pathname;
    axios({
      method: "get",
      url: `${appConfig.apiDomaine}${currentPathname}`,
    })
      .then(({ data }) => {
        console.log(data);
        // setLoading(false)
      })
      .catch(({ response }) => {
        console.log(response);
        // setLoading(false)
      });
  };

  const handlePlan = async () => {

    const abortController = new AbortController();
    await axios
        .get(`${appConfig.apiDomaine}/plan`)
        .then((response) => {
          // ls.set("plan", response.data.plan);
          // if (response.data.year_installation !== null) {
          //   ls.set("year_installation", response.data.year_installation);
          // }
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.log(error);
          }
        });
  }

  useEffect(() => {
    handlePlan();
    // handleDownload()
  }, []);

  return (
      <div className="kt-page-content-white kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--enabled kt-subheader--transparent kt-aside--enabled kt-aside--fixed kt-page--loading">
        
        <div className="d-flex flex-column justify-content-center align-items-center" style={{height: '100vh'}}>
          {/* loading */}
          {
            loading ? <>
              <Loader />
              <h6 className="mt-3">Téléchargement du recepissé en cours</h6>
            </> :
            <div className="d-flex flex-column justify-content-center align-items-center">
              {/* Icon de succes */}
              <i className="flaticon2-check-mark text-success" style={{fontSize: '80px'}}></i>
              <h6>Récépissé telechargé avec succès</h6>
              <button className="btn btn-primary mt-3">continuer</button>
            </div>
          }
        </div>
        
      </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlan: (plan) => dispatch(loadPlan(plan)),
    loadYear: (plan) => dispatch(loadYear(plan)),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(DownLoadReceipt)); 